import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../components/buttons/Button';

import './BoardTemplatePickerBodyListingCategoryButton.scss';

const CategoryButton = ({ children, categoryId, setNavigation }) => (
    <Button
        className="TemplatePickerListingButton CategoryButton"
        onClickFn={() => setNavigation(`category:${categoryId}`)}
    >
        {children}
    </Button>
);

CategoryButton.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string]),
    categoryId: PropTypes.string,
    setNavigation: PropTypes.func,
};

export default CategoryButton;
